import { NavLink } from "react-router-dom";
import { LayoutDashboard, FileText, ListChecks, Package, GitCompare, Building2, ScrollText, Boxes } from "lucide-react";
import { TransportadoraSelector } from "@/components/TransportadoraSelector";

const items = [
  { to: "/", label: "Visão Geral", icon: LayoutDashboard, testId: "nav-dashboard" },
  { to: "/transportadoras", label: "Transportadoras", icon: Building2, testId: "nav-transportadoras" },
  { to: "/notas", label: "Notas Fiscais", icon: Package, testId: "nav-notas" },
  { to: "/ctes", label: "Conhecimento de Transporte", icon: Boxes, testId: "nav-ctes" },
  { to: "/ocorrencias", label: "Ocorrências (Eventos)", icon: ListChecks, testId: "nav-ocorrencias" },
  { to: "/mudancas", label: "Mudanças", icon: GitCompare, testId: "nav-mudancas" },
  { to: "/arquivos", label: "Arquivos Processados", icon: FileText, testId: "nav-arquivos" },
  { to: "/regras", label: "Regras", icon: ScrollText, testId: "nav-regras" },
];

export const Sidebar = () => {
  return (
    <aside
      data-testid="app-sidebar"
      className="w-64 shrink-0 bg-white border-r border-[#E4E4E7] h-screen sticky top-0 flex flex-col"
    >
      <div className="px-6 py-7 border-b border-[#E4E4E7] flex flex-col gap-3">
        <img src="/logo_docss.png" alt="DocSS Logística" className="h-14 w-auto object-contain self-start" />
        <div className="text-[10px] tracking-[0.18em] uppercase text-[#52525B] font-semibold">
          Logística - OCOREN EDI
        </div>
      </div>

      {/* Seletor global de transportadora */}
      <div className="px-3 pt-4">
        <TransportadoraSelector />
      </div>

      <nav className="flex-1 py-6 px-3 space-y-1">
        {items.map(({ to, label, icon: Icon, testId }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={testId}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 text-sm font-medium rounded-md transition-colors ${
                isActive
                  ? "bg-[#09090B] text-white"
                  : "text-[#52525B] hover:bg-[#FAFAFA] hover:text-[#09090B]"
              }`
            }
          >
            <Icon size={16} strokeWidth={2} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="px-6 py-5 border-t border-[#E4E4E7]">
        <div className="text-[10px] uppercase tracking-[0.18em] text-[#52525B] font-semibold">
          v1.0 • PROCEDA
        </div>
        <div className="text-xs text-[#52525B] mt-1">Padrão EDI 340 / 540</div>
      </div>
    </aside>
  );
};

export default Sidebar;
